import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import translationEn from './locales/en/translation.json';

const resources = {
  en: {
    translation: translationEn
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // English only
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    react: {
      useSuspense: false,
    }
  });

export default i18n;